import { useEffect } from 'react';
import { Navigate, Outlet, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { isLocale, persistLocale, setI18nLocale, DEFAULT_LOCALE } from '@/client/i18n';
import { Seo } from '@/client/components/Seo';
import { PublicHeader } from './PublicHeader';
import { PublicFooter } from './PublicFooter';
import { CookieBanner } from '@/client/features/consent/CookieBanner';

export function PublicLayout() {
  const params = useParams();
  const { i18n, t } = useTranslation();
  const locale = params.locale;

  useEffect(() => {
    if (isLocale(locale)) {
      setI18nLocale(locale);
      persistLocale(locale);
      document.documentElement.lang = locale;
    }
  }, [locale, i18n]);

  if (!isLocale(locale)) {
    const segments = window.location.pathname.split('/').slice(2).join('/');
    const target = segments ? `/${DEFAULT_LOCALE}/${segments}` : `/${DEFAULT_LOCALE}/`;
    return <Navigate to={target} replace />;
  }

  return (
    <div className="relative min-h-screen flex flex-col overflow-x-hidden">
      {/* Ambient gradient backdrop fills the whole site under everything. */}
      <div
        className="fixed inset-0 -z-10"
        style={{
          background:
            'radial-gradient(ellipse 80% 60% at 15% -10%, rgba(193,167,226,0.30), transparent 60%),' +
            'radial-gradient(ellipse 70% 50% at 95% 30%, rgba(117,59,189,0.12), transparent 60%),' +
            'linear-gradient(180deg, #faf8fc 0%, #f3eff7 35%, #ebe1f5 100%)',
        }}
        aria-hidden
      />
      {/* Faint film grain for warmth */}
      <div className="grain-overlay" aria-hidden />

      <Seo
        title={t('seo.default_title')}
        description={t('seo.default_description')}
        locale={locale}
      />
      <PublicHeader />
      <main className="relative flex-1 z-10">
        <Outlet />
      </main>
      <PublicFooter />
      <CookieBanner />
    </div>
  );
}
